var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","overflow":"hidden"},style:(_vm.numberStyle)},[_vm._l((_vm.list),function(item,index){return _c('div',{key:item,class:_vm.itemClassName + 'item'+index},[(_vm.showNumber)?_c('div',_vm._l((_vm.numberList),function(number){return _c('p',[_vm._v(_vm._s(number))])}),0):_vm._e()])}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }